
<template>
  <v-card class="box-container ma-0 pa-0 px-2" align="center" justify="center" :width="getWidth" style="min-height: 350px">
    <v-card-actions class="row-header ma-0 pa-4">
      <v-col class="ma-0 pa-0">
        <v-row class="ma-0 pa-0" align="center" justify="center">
          <span>{{ title }}</span>
        </v-row>
        <v-divider></v-divider>
      </v-col>
    </v-card-actions>
    <v-card-actions class="row-content ma-0 pa-0 px-4">
      <v-row style="max-height: 600px" class="ma-0 pa-0">
        <v-col v-for="(header, idx) in getHeaders()" :key="idx" class="ma-0 pa-2" :cols="header.editorColspan ? header.editorColspan : 12">
          <t-color-input
            v-if="header.proptype == DataPropType.Color"
            v-model="item[header.value]"
            :label="header.text"
            :clearable="header.isNullable"
          ></t-color-input>
          <!-- <quill-editor v-else-if="header.proptype == DataPropType.HTMLString" :content="item[header.value]" @change="onQuillChange($event, item, header)" :options="editorOption" style="height: 500px; max-height: 500px">
          </quill-editor> -->
          <template v-else-if="header.proptype != DataPropType.Object">
            <t-text-field
              v-if="header.value.indexOf('.') > -1"
              :autofocus="idx == 0"
              v-model="item[header.value.split('.')[0]][header.value.split('.')[1]]"
              hide-details
              :density="IF.Density"
              :label="header.text"
              :class="IF.MyFont"
            >
            </t-text-field>
            <t-text-field v-else :autofocus="idx == 0" v-model="item[header.value]" hide-details :density="IF.Density" :label="header.text" :class="IF.MyFont">
            </t-text-field
          ></template>
          <v-autocomplete
            v-else
            :class="IF.MyFont"
            :autofocus="idx == 0"
            :clearable="header.isNullable"
            :clear-icon="header.isNullable ? 'mdi-close' : ''"
            no-data-text="Не са намерени данни по посочения критерий!"
            :items="getTableItems(header.value)"
            v-model="item[header.value]"
            :label="header.text"
            return-object
            hide-details
            :density="IF.Density"
          >
            <!-- <v-select v-else :key="idx" :items="getTableItems(header.value)" v-model="item[header.value.substring(0, header.value.indexOf('.'))]" :label="header.text" return-object hide-details @change="change"> -->
            <template v-slot:selection="data">
              <span class="ma-0 pa-0" style="white-space: pre" :style="data.item.Color ? 'background: ' + data.item.Color : ''">{{
                data.item.toString()
              }}</span>
            </template>
            <template v-slot:item="data">
              <span class="ma-0 pa-0" style="white-space: nowrap" :style="data.item.Color ? 'background: ' + data.item.Color : ''">{{
                data.item.toString()
              }}</span>
            </template>
          </v-autocomplete>
        </v-col>
      </v-row>
    </v-card-actions>
    <v-card-actions class="row-header ma-0 pa-0" style>
      <v-col>
        <v-row class="ma-2 pa-0" align="center" justify="center">
          <v-col cols="5" class="ma-0 pa-0" justify="start">
            <v-card
              align="center"
              :width="isOnMobile ? '120' : '150'"
              style="display: flex; cursor: pointer; height: 100%"
              :color="Colors.IconColor"
              class="pa-2 white--text"
              :class="IF.MyFont"
              @click="confirm(false)"
            >
              <span style="white-space: normal; word-wrap: break-word; margin: auto auto">{{ buttonCancelText }}</span>
            </v-card>
          </v-col>
          <v-col cols="2" class="ma-0 pa-0"></v-col>
          <v-col cols="5" class="ma-0 pa-0">
            <v-card
              align="center"
              :width="isOnMobile ? '120' : '150'"
              style="display: flex; cursor: pointer; height: 100%"
              :color="Colors.IconColor"
              class="pa-2 white--text"
              :class="IF.MyFont"
              @click="confirm(true)"
            >
              <span style="white-space: normal; word-wrap: break-word; margin: auto auto">{{ buttonOKText }}</span>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-card-actions>
  </v-card>
</template>

<script>
import DataManager from "@/data/DataManager";
import { DataPropType } from "@/data/DataFilter";

export default {
  props: {},
  data() {
    return {
      title: "Редакция",
      headers: null,
      item: null,
      buttonOKText: "ОК",
      buttonCancelText: "Отказ",
      selected: null,
      width: null,
      nestedItems: {},
      DataPropType: DataPropType,
      editorOption: {
        modules: {
          toolbar: [
            [{ size: [] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            ["bold", "italic", "underline", "strike"],
            [{ color: [] }, { background: [] }],
            [{ script: "super" }, { script: "sub" }],
            ["blockquote", "code-block"],
            [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
            [{ direction: "rtl" }, { align: [] }],
            ["link", "image", "video", "formula"],
            ["clean"],
          ],
        },
      },
    };
  },
  computed: {
    getWidth() {
      return this.width ? this.width : this.isOnMobile ? 360 : 500;
    },
  },
  methods: {
    onQuillChange(event, item, header) {
      item[header.value] = event.html;
    },
    getTableItems(prop) {
      return DataManager.getTableItems(prop);
    },
    getHeaders() {
      if (!this.headers) return [];
      return this.headers.filter((h) => h.isForEditing && h.value != "Deleted" && !h.value.contains("my_custom") && h.value != "edit" && h.value != "delete");
    },
    propIsObject(prop) {
      return prop.indexOf(".") != -1;
    },
    confirm(success) {
      // console.log(JSON.stringify(this.item));
      if (success) {
        var notFilledHeaders = this.getHeaders().filter((h) => !h.isNullable && !this.item[h.value]);
        if (notFilledHeaders.length > 0) {
          this.dialog.showError('Полето "' + notFilledHeaders[0].text + '" не може да има празна стойност!', { location: "center" });
          return;
        }
        this.dialog.result = this.item;
      } else {
        this.dialog.result = null;
      }
      this.dialog.close();
    },
  },
  watch: {},
  created() {
    // this.item = JSON.parse(JSON.stringify(this.dialog.data));
    // this.item = Object.assign({}, this.dialog.data);

    if (this.dialog.options) {
      this.title = this.dialog.options.title || "Редакция";
      if (this.dialog.options.headers != undefined) {
        this.headers = this.dialog.options.headers;
        this.item = Object.assign({}, this.dialog.data);
        delete this.item.Deleted;
        delete this.item.my_custom_id;
        delete this.item.edit;
        delete this.item.delete;

        // this.item.Id = Object.byString(this.dialog.data, "Id");
        // this.getHeaders().forEach((h) => {
        //   this.item[h.value] = Object.byString(this.dialog.data, h.value);
        // });
      }
      if (this.dialog.options.buttonOKText != undefined) {
        this.buttonOKText = this.dialog.options.buttonOKText;
      }
      if (this.dialog.options.buttonCancelText != undefined) {
        this.buttonCancelText = this.dialog.options.buttonCancelText;
      }
      if (this.dialog.options.width != undefined) {
        this.width = this.dialog.options.width;
      }
    }
  },
  mounted() {},
};
</script>